
enum UserFilterEvents {
    resetUserfilter = "[UserFilterEvent] Resetfilter"
}

export default UserFilterEvents;
